import collect from '@common/collect'

const plugin = {
  install(Vue) {
    window._gaq = window._gaq || []
    window._gaq.push(['_setAccount', 'UA-251384-16'])
    window._gaq.push(['_trackPageview'])

    let collectInfo = {}

    const getGa = () => {
      const ga = document.createElement('script')
      ga.type = 'text/javascript'
      ga.async = true
      ga.src = 'https://ssl.google-analytics.com/ga.js'
      document.body.appendChild(ga)
    }

    const getBa = () => {
      const ba = document.createElement('script')
      ba.type = 'text/javascript'
      ba.async = true
      ba.src = '//hm.baidu.com/h.js?3a3829a8eae7d791fc22e7eb4990aea5'
      document.body.appendChild(ba)
    }

    /**
     * 订阅了上报组件上报后的事件，把数据同步一份到无痕埋点
     */
    let afterCollect = 0
    collect.subscribe('afterCollect', (contentData) => {
      const _ssjCollectFn = () => {
        if (window.ssjCollect &&  window.ssjCollect.collect) {
          const commons = contentData.commons || {}
          const event = contentData.events[0] || {}
          const obj = {
            tt: event.title || '',
            uuid: commons.udid || '',
            et: event.etype || '',
            c1: 'business',
          }
          console.log('afterCollect: 无痕埋点数据同步')
          console.log(obj)
          window.ssjCollect.collect(obj)
        } else if (afterCollect < 10) {
          afterCollect = afterCollect + 1
          setTimeout(_ssjCollectFn, 300)
        }
      }
      _ssjCollectFn()
    }, true)

    /**
     * 上报方法
     * @param {string} flowName finance
     * @param {string} pageName finance_xxx
     * @param {string} title 页面名称
     * @param {object} params 参数 { productId: 'xxx', orderId: 'xxx', amount: 1000 }
     */
    const fnCollect = (flowName, pageName, title, params = {}) => {
      collectInfo = { title, params }
      collect.init(flowName, pageName)
      collect.sendRequest(title, 'view', params)
      setTimeout(() => {
        getGa()
      }, 0)
      setTimeout(() => {
        getBa()
      }, 0)
    }

    if (!Vue.$ssvue) {
      Vue.$ssvue = {
        collect: fnCollect,
        collectSendRequest: collect.sendRequest,
      }
    } else {
      Vue.$ssvue.collect = fnCollect
      Vue.$ssvue.collectSendRequest = collect.sendRequest
    }

    Vue.directive('collect', {
      inserted(el, { value }) {
        if (value.canBind || value.canBind === undefined) {
          if (!value.events || value.events.length === 0) {
            el.addEventListener('click', () => {
              collect.sendRequest(`${collectInfo.title}-${value.name}`, 'click', collectInfo.params)
            })
          } else {
            for (const event of value.events || []) {
              el.addEventListener(event, () => {
                collect.sendRequest(`${collectInfo.title}-${value.name}`, event, collectInfo.params)
              })
            }
          }
        }
      },
      componentUpdated(el, { value, oldValue }) {
        if (!oldValue.canBind && value.canBind) {
          el.addEventListener('click', () => {
            collect.sendRequest(`${collectInfo.title}-${value.name}`, 'click', collectInfo.params)
          })
        }
      }
    })

    Vue.mixin({
      created: () => {
        this.$ssvue = Vue.$ssvue
      }
    })
  }
}

export default plugin
export const install = plugin.install



// WEBPACK FOOTER //
// ./node_modules/@finance/ssvue/src/plugins/collect/index.js